import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DonateAPIService {
  constructor(private api: ApiService) {}

  public postDonation(asset, donation) {
    return this.api.post(`donate/${asset}`, donation);
  }

  public updateDesignation(type, id, designation) {
    if (type === 'transaction') {
      return this.api.post(`donate/common/${id}/designation`, designation);
    } else if (type === 'schedule') {
      return this.api.post(`recurring/${id}/designation`, designation);
    }
    throw Observable.throw('not valid');
  }

  public updateCorporateMatching(transId, companyId) {
    return this.api.post(`donate/common/${transId}/corporate-matching`, {
      double_the_donation_company_id: companyId
    });
  }
}
